import { Component } from 'react';
import propTypes from 'prop-types';
import bindActionCreators from 'redux/lib/bindActionCreators';
import { connect } from 'react-redux';

import getDisplayName from '../getDisplayName';
import * as actions from './actions';

const withTracker = (WrappedComponent) => {
  const displayName = getDisplayName(WrappedComponent);

  class Tracker extends Component {
    static displayName = `Tracker(${displayName})`;

    static propTypes = {
      dispatch: propTypes.func.isRequired,
    };

    UNSAFE_componentWillMount() {
      this.tracker = bindActionCreators(actions, this.props.dispatch);
    }

    render() {
      return <WrappedComponent {...this.props} tracker={this.tracker} />;
    }
  }

  return connect()(Tracker);
};

export default withTracker;
